document.addEventListener('DOMContentLoaded', () => {
  const COMMENT_PENDING_KEY = 'asqCommentPending';
  const COMMENT_FLASH_KEY = 'asqCommentFlash';

  const parseStorageJSON = (value) => {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const showCommentFlash = (flash) => {
    if (!flash || !flash.anchorId || !flash.message) return;

    const section = document.getElementById(flash.anchorId);
    if (!section) return;

    const form = section.querySelector('[data-asq-comment-form]');
    if (!form) return;

    const existing = form.querySelector('[data-asq-comment-flash]');
    if (existing) existing.remove();

    const notice = document.createElement('div');
    notice.className = 'asq-form-status asq-form-status--success';
    notice.setAttribute('role', 'status');
    notice.setAttribute('data-asq-comment-flash', 'true');
    notice.textContent = flash.message;

    form.insertBefore(notice, form.firstChild);
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const currentPathname = window.location.pathname;
  const pendingComment = parseStorageJSON(sessionStorage.getItem(COMMENT_PENDING_KEY));

  if (pendingComment) {
    const isOnReturnPage = currentPathname === pendingComment.returnPathname;
    const hasSuccessState = Boolean(document.querySelector('.form__message[role="status"], .form-status-list.form__message[role="status"]'));
    const hasErrorState = Boolean(document.querySelector('.form__message[role="alert"], .form-status-list.caption-large'));

    if (!isOnReturnPage && hasSuccessState && !hasErrorState) {
      sessionStorage.setItem(
        COMMENT_FLASH_KEY,
        JSON.stringify({
          anchorId: pendingComment.anchorId,
          message: pendingComment.message,
        })
      );
      sessionStorage.removeItem(COMMENT_PENDING_KEY);
      window.location.replace(pendingComment.returnTo);
      return;
    }

    if (isOnReturnPage) {
      sessionStorage.setItem(
        COMMENT_FLASH_KEY,
        JSON.stringify({
          anchorId: pendingComment.anchorId,
          message: pendingComment.message,
        })
      );
      sessionStorage.removeItem(COMMENT_PENDING_KEY);
    } else if (hasErrorState) {
      sessionStorage.removeItem(COMMENT_PENDING_KEY);
    }
  }


  const url = new URL(window.location.href);
  const submittedFromQuery = url.searchParams.get('asq_comment_submitted') === '1';

  if (submittedFromQuery) {
    const form = document.querySelector('[data-asq-comment-form]');
    const anchorId = form?.dataset.asqCommentAnchor || 'asq-comments';
    const message =
      form?.dataset.asqCommentSuccessMessage ||
      'Tu comentario fue enviado y quedó pendiente de aprobación antes de publicarse.';

    showCommentFlash({ anchorId, message });

    url.searchParams.delete('asq_comment_submitted');
    const cleaned = `${url.pathname}${url.search}${url.hash || '#asq-comments'}`;
    window.history.replaceState({}, '', cleaned);
  }

  const pendingFlash = parseStorageJSON(sessionStorage.getItem(COMMENT_FLASH_KEY));
  if (pendingFlash) {
    showCommentFlash(pendingFlash);
    sessionStorage.removeItem(COMMENT_FLASH_KEY);
  }

  document.querySelectorAll('[aria-disabled="true"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });

  document.querySelectorAll('[data-asq-comment-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const returnTo = form.dataset.asqCommentReturnTo || `${window.location.pathname}${window.location.hash}`;
      const anchorId = form.dataset.asqCommentAnchor || '';
      const message = form.dataset.asqCommentSuccessMessage || 'Tu comentario fue enviado correctamente.';
      const returnUrl = new URL(returnTo, window.location.origin);

      sessionStorage.setItem(
        COMMENT_PENDING_KEY,
        JSON.stringify({
          returnTo: `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`,
          returnPathname: returnUrl.pathname,
          anchorId,
          message,
        })
      );
    });
  });

  document.querySelectorAll('[data-asq-header]').forEach((header) => {
    const toggle = header.querySelector('[data-asq-toggle]');
    const nav = header.querySelector('[data-asq-nav]');

    if (!toggle || !nav) return;

    const closeMenu = () => {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        closeMenu();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        closeMenu();
      }
    });
  });
});
